import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';
import { selectUtilData } from '../../utils/store/utils.selectors';

export const selectAuthState = createFeatureSelector<AuthState>('auth');
export const selectUserAuth = createSelector(
    selectAuthState,
    (state: AuthState) => state.data
);
export const selectAuthClaims = createSelector(
    selectAuthState,
    (state: AuthState) => state.data.claims
);
export const selectAuthToken = createSelector(
    selectAuthState,
    (state: AuthState) => state.data.jwt
);

export const selectEnabledApplications = createSelector(
    selectUtilData,
    selectAuthClaims,
    (utilData, claims) =>
        utilData.application.idSort
            .map((access_key: string) => {
                const application = utilData.application.idMap[access_key];
                const updatedApplication = {
                    ...application,
                    value: application.access_key
                };
                return updatedApplication;
            })
            .filter(
                app =>
                    app.home ||
                    claims?.enabled_sso_apps?.includes(app.access_key)
            )
);
